// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5_qAm","imageWrapper":"styles_imageWrapper__Hbxri","loader":"styles_loader__xnCEJ"};